// Marketplace category pages — drawer filtres + bouton flottant + favoris
// (Le panier est géré dans site-header.js car visible sur toutes les pages)

// ─────────────────────────────────────────────────────────────
// Drawer filtres
// ─────────────────────────────────────────────────────────────
function fermerFilters() {
  const drawer = document.querySelector("[data-marketplace-drawer]");
  if (!drawer) return;
  drawer.classList.remove("is-open");
  document.body.style.overflow = "";
}

document.querySelectorAll("[data-drawer-open]").forEach((trigger) => {
  trigger.addEventListener("click", () => {
    const drawer = document.querySelector("[data-marketplace-drawer]");
    if (!drawer) return;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
  });
});

document.querySelectorAll("[data-drawer-close]").forEach((trigger) => {
  trigger.addEventListener("click", fermerFilters);
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") fermerFilters();
});

document.querySelectorAll(".marketplace-drawer__option:not(a)").forEach((opt) => {
  opt.addEventListener("click", () => opt.classList.toggle("is-active"));
});

document.querySelector("[data-drawer-reset]")?.addEventListener("click", () => {
  document.querySelectorAll(".marketplace-drawer__option.is-active").forEach((o) => o.classList.remove("is-active"));
});
document.querySelector("[data-drawer-apply]")?.addEventListener("click", fermerFilters);

// ─────────────────────────────────────────────────────────────
// Bouton flottant filtres : apparaît quand la barre n'est plus visible
// ─────────────────────────────────────────────────────────────
const floatBtn = document.querySelector("[data-filters-float]");
const filtersBar = document.querySelector("[data-filters-bar]");
if (floatBtn && filtersBar && "IntersectionObserver" in window) {
  const obs = new IntersectionObserver(
    ([entry]) => floatBtn.classList.toggle("is-visible", !entry.isIntersecting),
    { rootMargin: "0px 0px -10px 0px", threshold: 0 }
  );
  obs.observe(filtersBar);
}

document.querySelectorAll("[data-sdv-sort-select]").forEach((select) => {
  select.addEventListener("change", () => {
    select.form?.submit();
  });
});

// ─────────────────────────────────────────────────────────────
// Cœurs favoris
// ─────────────────────────────────────────────────────────────
document.querySelectorAll(".product-card__heart").forEach((heart) => {
  heart.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    heart.classList.toggle("is-liked");
  });
});

// ─────────────────────────────────────────────────────────────
// Page produit : galerie + accordéon unique
// ─────────────────────────────────────────────────────────────
const productGallery = document.querySelector("[data-product-gallery]");
const productThumbs = [...document.querySelectorAll("[data-product-thumb]")];

if (productGallery && productThumbs.length) {
  const slides = [...productGallery.querySelectorAll(".product-gallery__main")];

  function setActiveThumb(index) {
    productThumbs.forEach((thumb, i) => thumb.classList.toggle("is-active", i === index));
  }

  productThumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const index = Number(thumb.dataset.productThumb || 0);
      slides[index]?.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      setActiveThumb(index);
    });
  });

  productGallery.addEventListener("scroll", () => {
    const index = Math.round(productGallery.scrollLeft / Math.max(1, productGallery.clientWidth));
    setActiveThumb(Math.max(0, Math.min(index, productThumbs.length - 1)));
  }, { passive: true });
}

document.querySelectorAll(".product-accordion details").forEach((detail) => {
  detail.addEventListener("toggle", () => {
    if (!detail.open) return;
    document.querySelectorAll(".product-accordion details").forEach((other) => {
      if (other !== detail) other.removeAttribute("open");
    });
  });
});

// ─────────────────────────────────────────────────────────────
// Page vendeur : onglets articles / avis
// ─────────────────────────────────────────────────────────────
const vendorTabs = [...document.querySelectorAll("[data-vendor-tab]")];
const vendorPanels = [...document.querySelectorAll("[data-vendor-panel]")];

if (vendorTabs.length && vendorPanels.length) {
  function activateVendorTab(target) {
    vendorTabs.forEach((tab) => {
      const isActive = tab.dataset.vendorTab === target;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", String(isActive));
    });

    vendorPanels.forEach((panel) => {
      panel.hidden = panel.dataset.vendorPanel !== target;
    });
  }

  vendorTabs.forEach((tab) => {
    tab.addEventListener("click", () => activateVendorTab(tab.dataset.vendorTab));
  });
}

// ─────────────────────────────────────────────────────────────
// Espace vendeur SDV : hydratation via Shopify App Proxy → Vercel → Webkul
// ─────────────────────────────────────────────────────────────
const sdvVendorDashboard = document.querySelector("[data-sdv-vendor-dashboard]");

if (sdvVendorDashboard) {
  const proxyBase = (sdvVendorDashboard.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  const profileForm = sdvVendorDashboard.querySelector("[data-sdv-vendor-profile-form]");
  const profileStatus = sdvVendorDashboard.querySelector("[data-sdv-profile-status]");

  function setVendorText(selector, value) {
    const node = sdvVendorDashboard.querySelector(selector);
    if (node && value !== undefined && value !== null && value !== "") node.textContent = value;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function profileFieldMap(fields) {
    return Object.fromEntries((fields || []).map((field) => [field.key, field.value || ""]));
  }

  function setProfileInput(name, value) {
    const input = profileForm?.querySelector(`[name="${name}"]`);
    if (input && value !== undefined && value !== null) input.value = value;
  }

  function publicProfileFields(data) {
    return profileFieldMap(data.publicProfile?.metaobject?.fields);
  }

  function renderProfilePreview() {
    if (!profileForm) return;
    const formData = new FormData(profileForm);
    const name = String(formData.get("name") || "").trim() || "Vendeur";
    const location = String(formData.get("location") || "").trim() || "France";
    const bio = String(formData.get("bio") || "").trim() || "Votre description apparaîtra ici sur la page publique.";
    const avatarUrl = String(formData.get("avatarUrl") || "").trim();
    const specialties = String(formData.get("specialties") || "Mode vintage,Objets rares")
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean)
      .slice(0, 5);

    const previewName = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-name]");
    const previewMeta = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-meta]");
    const previewBio = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-bio]");
    const previewAvatar = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-avatar]");
    const previewTags = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-tags]");

    if (previewName) previewName.textContent = name;
    if (previewMeta) previewMeta.textContent = `@${slugify(name) || "vendeur"} · ${location}`;
    if (previewBio) previewBio.textContent = bio;
    if (previewAvatar) {
      previewAvatar.innerHTML = avatarUrl
        ? `<img src="${escapeHtml(avatarUrl)}" alt="${escapeHtml(name)}" loading="lazy">`
        : escapeHtml(name.slice(0, 1).toUpperCase());
    }
    if (previewTags) {
      previewTags.innerHTML = specialties.map((tag) => `<span>${escapeHtml(tag)}</span>`).join("");
    }
  }

  function setProfileStatus(message, type) {
    if (!profileStatus) return;
    profileStatus.textContent = message || "";
    profileStatus.classList.toggle("is-error", type === "error");
    profileStatus.classList.toggle("is-success", type === "success");
  }

  function renderProducts(products) {
    const list = sdvVendorDashboard.querySelector("[data-sdv-products-list]");
    const empty = sdvVendorDashboard.querySelector("[data-sdv-products-empty]");
    if (!list || !Array.isArray(products) || products.length === 0) {
      if (empty) empty.textContent = "Vous n'avez pas encore de produits actifs.";
      return;
    }

    list.innerHTML = products.map((product) => {
      const title = escapeHtml(product.title || "Produit");
      const status = escapeHtml(product.status || "En attente");
      const price = escapeHtml(product.price ? `${product.price} €` : "Prix à confirmer");
      const imageUrl = escapeHtml(product.imageUrl || "");

      return `
      <article class="product-card">
        <a class="product-card__media" href="#" aria-label="${title}">
          ${
            imageUrl
              ? `<img src="${imageUrl}" alt="${title}" loading="lazy">`
              : `<div style="width:100%;aspect-ratio:4/5;background:var(--pierre-100);"></div>`
          }
        </a>
        <div class="product-card__body">
          <p class="product-card__vendor">${status}</p>
          <h3 class="product-card__title">${title}</h3>
          <p class="product-card__price">${price}</p>
        </div>
      </article>
    `;
    }).join("");
  }

  async function loadVendorDashboard() {
    try {
      const response = await fetch(`${proxyBase}/seller/summary`, { credentials: "same-origin" });
      const data = await response.json();
      if (!response.ok) throw new Error(data.erreur || "Erreur Webkul");

      setVendorText("[data-sdv-seller-name]", data.seller?.name);
      setVendorText("[data-sdv-seller-meta]", data.seller?.handle ? `@${data.seller.handle}` : data.seller?.email);
      const publicLink = sdvVendorDashboard.querySelector("[data-sdv-seller-public-link]");
      if (publicLink && (data.seller?.publicPath || data.seller?.handle)) {
        publicLink.href = data.seller?.publicPath || `/pages/vendeurs/${encodeURIComponent(data.seller.handle)}`;
      }
      const previewLink = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-link]");
      if (previewLink && (data.seller?.publicPath || data.seller?.handle)) {
        previewLink.href = data.seller?.publicPath || `/pages/vendeurs/${encodeURIComponent(data.seller.handle)}`;
      }

      if (profileForm) {
        const fields = publicProfileFields(data);
        setProfileInput("name", fields.name || data.seller?.name || "");
        setProfileInput("badge", fields.badge || "Vendeur sélectionné");
        setProfileInput("shippingDelay", fields.shipping_delay || "1-2 j");
        setProfileInput("bio", fields.bio || "");
        setProfileInput("location", fields.location || data.seller?.city || "");
        setProfileInput("instagram", fields.instagram || "");
        setProfileInput("website", fields.website || "");
        setProfileInput("avatarUrl", fields.avatar_url || "");
        setProfileInput("specialties", fields.specialties || "Mode vintage,Objets rares,Sélection SDV");
        setProfileInput("profileTitle", fields.profile_title || "");
        setProfileInput("profileIntro", fields.profile_intro || "");
        renderProfilePreview();
      }

      const stats = data.dashboard?.store_statics || {};
      setVendorText("[data-sdv-stat='products']", stats.total_products ?? data.products?.length ?? 0);
      setVendorText("[data-sdv-stat='sales']", data.dashboard?.last_3_orders?.length ?? 0);
      setVendorText("[data-sdv-stat='revenue']", "— €");
      setVendorText("[data-sdv-stat='rating']", "—");
      renderProducts(data.products || []);
    } catch (error) {
      const empty = sdvVendorDashboard.querySelector("[data-sdv-products-empty]");
      if (empty) empty.textContent = error.message || "Connexion Webkul indisponible.";
    }
  }

  profileForm?.addEventListener("input", renderProfilePreview);
  profileForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    setProfileStatus("Enregistrement de la page publique...", "");
    const submit = profileForm.querySelector("button[type='submit']");
    submit?.setAttribute("disabled", "disabled");

    try {
      const payload = Object.fromEntries(new FormData(profileForm).entries());
      const response = await fetch(`${proxyBase}/seller/profile`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.erreur || "Mise à jour impossible.");

      const publicPath = data.path || profileForm.dataset.publicLink;
      const publicLink = sdvVendorDashboard.querySelector("[data-sdv-seller-public-link]");
      const previewLink = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-link]");
      if (publicPath) {
        if (publicLink) publicLink.href = publicPath;
        if (previewLink) previewLink.href = publicPath;
      }
      setProfileStatus("Page publique mise à jour.", "success");
    } catch (error) {
      setProfileStatus(error.message || "Erreur pendant l'enregistrement.", "error");
    } finally {
      submit?.removeAttribute("disabled");
    }
  });

  loadVendorDashboard();
}

// ─────────────────────────────────────────────────────────────
// Ajouter produit vendeur : tunnel Shopify → App Proxy → Webkul
// ─────────────────────────────────────────────────────────────
const sdvListingForm = document.querySelector("[data-sdv-listing-form]");

if (sdvListingForm) {
  const proxyBase = (sdvListingForm.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  const backUrl = sdvListingForm.dataset.backUrl || "/pages/espace-vendeur";
  const intro = sdvListingForm.querySelector("[data-listing-intro]");
  const shell = sdvListingForm.querySelector("[data-listing-shell]");
  const startButton = sdvListingForm.querySelector("[data-listing-start]");
  const backIntroButton = sdvListingForm.querySelector("[data-listing-back-intro]");
  const categoryValue = sdvListingForm.querySelector("[data-listing-category-value]");
  const categoryHandle = sdvListingForm.querySelector("[data-listing-category-handle]");
  const subcategoryValue = sdvListingForm.querySelector("[data-listing-subcategory-value]");
  const subcatWrap = sdvListingForm.querySelector("[data-subcat-wrap]");
  const subcatSelect = sdvListingForm.querySelector("[data-subcat-select]");
  const sidebarTitle = sdvListingForm.querySelector("[data-sidebar-title]");
  const sidebarCategory = sdvListingForm.querySelector("[data-sidebar-category]");
  const titleInput = sdvListingForm.querySelector("[data-title-input]");
  const priceInput = sdvListingForm.querySelector("[data-price-input]");
  const photoInput = sdvListingForm.querySelector("[data-photo-input]");
  const statusNode = sdvListingForm.querySelector("[data-listing-status]");
  const submitForm = sdvListingForm.querySelector("[data-listing-submit]");
  let currentStep = 1;
  let selectedCategoryLabel = "";
  let selectedImageAttachment = "";

  const subcats = {
    mode: ["Vêtements femme", "Vêtements homme", "Chaussures", "Accessoires", "Bijoux", "Sacs & Maroquinerie"],
    mobilier: ["Luminaires", "Assises", "Tables & Bureaux", "Rangements", "Déco & Objets", "Arts de la table"],
    vinyles: ["Vinyles 33 tours", "Vinyles 45 tours", "BD & Livres", "Affiches & Posters", "Jouets & Jeux", "Appareils audio"],
    luxe: ["Maroquinerie", "Horlogerie", "Joaillerie & Bijoux", "Mode luxe", "Arts de la table luxe"],
    auto: ["Pièces & Accessoires auto", "Pièces & Accessoires moto", "Vêtements auto/moto", "Objets & Signalétique", "Modèles réduits"],
  };

  function setStatus(message, type) {
    if (!statusNode) return;
    statusNode.textContent = message || "";
    statusNode.classList.toggle("is-error", type === "error");
    statusNode.classList.toggle("is-success", type === "success");
  }

  function slugify(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function filterTag(prefix, value) {
    const slug = slugify(value);
    return slug ? `${prefix}:${slug}` : "";
  }

  function formatEuros(value) {
    return value.toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + " €";
  }

  function updateIntroState() {
    const category = sdvListingForm.querySelector("input[name='listing_category']:checked");
    const ok = Boolean(category && subcatSelect?.value);
    startButton?.toggleAttribute("disabled", !ok);
  }

  function goToStep(step) {
    currentStep = step;
    sdvListingForm.querySelectorAll("[data-step-panel]").forEach((panel) => {
      panel.classList.toggle("is-active", panel.dataset.stepPanel === String(step));
    });
    sdvListingForm.querySelectorAll("[data-step-nav]").forEach((nav) => {
      const navStep = Number(nav.dataset.stepNav || 0);
      nav.classList.toggle("is-active", navStep === step);
      nav.classList.toggle("is-done", navStep < step);
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const value = String(reader.result || "");
        resolve(value.includes(",") ? value.split(",")[1] : value);
      };
      reader.onerror = () => reject(new Error("Lecture image impossible."));
      reader.readAsDataURL(file);
    });
  }

  function updatePriceCalc() {
    const price = Number(priceInput?.value || 0);
    const commission = price * 0.15;
    const calcPrice = sdvListingForm.querySelector("[data-calc-price]");
    const calcCommission = sdvListingForm.querySelector("[data-calc-commission]");
    const calcReceived = sdvListingForm.querySelector("[data-calc-received]");

    if (price > 0) {
      if (calcPrice) calcPrice.textContent = formatEuros(price);
      if (calcCommission) calcCommission.textContent = "- " + formatEuros(commission);
      if (calcReceived) calcReceived.textContent = formatEuros(price - commission);
      return;
    }

    [calcPrice, calcCommission, calcReceived].forEach((node) => {
      if (node) node.textContent = "—";
    });
  }

  sdvListingForm.querySelectorAll("input[name='listing_category']").forEach((radio) => {
    radio.addEventListener("change", () => {
      selectedCategoryLabel = radio.dataset.label || radio.value;
      const key = radio.dataset.subcat || "";
      if (subcatSelect) {
        subcatSelect.innerHTML = "<option value=\"\">Sélectionner la sous-catégorie…</option>";
        (subcats[key] || []).forEach((subcat) => {
          const option = document.createElement("option");
          option.value = slugify(subcat);
          option.textContent = subcat;
          subcatSelect.appendChild(option);
        });
      }
      subcatWrap?.classList.add("is-visible");
      if (sidebarCategory) sidebarCategory.textContent = selectedCategoryLabel;
      if (categoryValue) categoryValue.value = selectedCategoryLabel;
      if (categoryHandle) categoryHandle.value = radio.value;
      updateIntroState();
    });
  });

  subcatSelect?.addEventListener("change", () => {
    if (subcategoryValue) {
      const selected = subcatSelect.options[subcatSelect.selectedIndex];
      subcategoryValue.value = selected?.textContent || subcatSelect.value;
    }
    updateIntroState();
  });

  startButton?.addEventListener("click", () => {
    if (startButton.hasAttribute("disabled")) return;
    if (intro) intro.hidden = true;
    if (shell) shell.hidden = false;
    goToStep(1);
  });

  backIntroButton?.addEventListener("click", () => {
    if (shell) shell.hidden = true;
    if (intro) intro.hidden = false;
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  titleInput?.addEventListener("input", () => {
    if (sidebarTitle) sidebarTitle.textContent = titleInput.value.trim() || "Nouveau produit";
  });

  sdvListingForm.querySelectorAll("[data-next-step]").forEach((button) => {
    button.addEventListener("click", () => {
      const next = Number(button.dataset.nextStep || currentStep + 1);
      goToStep(next);
    });
  });

  sdvListingForm.querySelectorAll("[data-prev-step]").forEach((button) => {
    button.addEventListener("click", () => {
      const previous = Number(button.dataset.prevStep || currentStep - 1);
      goToStep(previous);
    });
  });

  priceInput?.addEventListener("input", updatePriceCalc);

  photoInput?.addEventListener("change", async () => {
    const files = Array.from(photoInput.files || []).slice(0, 5);
    const slots = Array.from(sdvListingForm.querySelectorAll("[data-photo-slot]"));
    slots.forEach((slot, index) => {
      const file = files[index];
      if (!file) return;
      const img = document.createElement("img");
      img.src = URL.createObjectURL(file);
      img.alt = file.name;
      slot.innerHTML = "";
      slot.appendChild(img);
    });

    if (files[0]) {
      try {
        selectedImageAttachment = await fileToBase64(files[0]);
      } catch (error) {
        selectedImageAttachment = "";
        setStatus(error.message || "Image impossible à préparer.", "error");
      }
    }
  });

  sdvListingForm.querySelectorAll("[data-photo-slot]").forEach((slot) => {
    slot.addEventListener("click", () => photoInput?.click());
  });

  submitForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    setStatus("Envoi en cours...", "");
    const submit = submitForm.querySelector("button[type='submit']");
    submit?.setAttribute("disabled", "disabled");

    try {
      const formData = new FormData(submitForm);
      const payload = Object.fromEntries(formData.entries());
      payload.tags = [
        filterTag("sdv-cat", payload.listing_category),
        filterTag("sdv-subcat", payload.subCategory),
        filterTag("sdv-brand", payload.brand),
        filterTag("sdv-size", payload.size),
        filterTag("sdv-condition", payload.condition),
        filterTag("sdv-color", payload.color),
        filterTag("sdv-decade", payload.decade),
        payload.isVintage ? "sdv-flag:vintage-authentique" : "",
        payload.hasCertificate ? "sdv-flag:certificat-disponible" : "",
      ].filter(Boolean).join(", ");
      payload.sku = payload.sku || `SDV-${Date.now()}`;
      if (selectedImageAttachment) payload.imageAttachment = selectedImageAttachment;

      const response = await fetch(`${proxyBase}/products`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.erreur || "Création impossible.");

      setStatus("Produit envoyé en validation. Retour à votre espace vendeur...", "success");
      setTimeout(() => {
        window.location.href = backUrl;
      }, 900);
    } catch (error) {
      setStatus(error.message || "Erreur pendant l'envoi.", "error");
    } finally {
      submit?.removeAttribute("disabled");
    }
  });
}
